import React, { Component } from 'react';

export class PackageFilter2 extends Component {
    
    filterPackages = (event) => {
        console.log('checled', event.target.checked);
        this.props.filterPackages(event.target.value, event.target.checked);
    }

    isChecked = () => {
        return this.props.packageFilter.checked;
    }

    render() {

        return (    
            <label className="list-group-item d-flex justify-content-start align-items-center">
                <input className="form-check-input me-2" type="checkbox" value={this.props.packageFilter.slug} onChange={this.filterPackages}
                checked={this.isChecked()}
                />
                <div dangerouslySetInnerHTML={{__html: this.props.packageFilter.name}} />
               
                <span className="badge bg-primary rounded-pill">{this.props.packageFilter.count}</span>
            </label>
        )
    }
}

export default PackageFilter2